import React from 'react';
import {Helmet} from "react-helmet";

export class NotFound extends React.Component {

  render(){
    return (
      <div className={"not-found-container"}>
      	<Helmet>
          <title>404 Not Found | Obelux Aviation Lights</title>
          <meta name="og:image" content={require('../../assets/images/obelux.jpg')}></meta>
        </Helmet>

        <h2>Error 404</h2>
        <h1>Sorry, but we can't find the page you're looking for.</h1>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/not-found/NotFound.js